<template>
  <div>
    <Header></Header>
    <div v-if="isLogin">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import Header from "@/P09_BaiCaiHui/components/Header.vue";
import Bottom from "@/P09_BaiCaiHui/components/Foot.vue";
import Bus from "@/P09_BaiCaiHui/components/bus.js";
export default {
  components: { Header, Bottom },
  data() {
    return {
      isLogin: true,
    };
  },
  created() {
    Bus.$on("isLoginFun", (flag) => {
      this.isLogin = flag;
    });
  },
};
</script>